import { api_without_cancellation } from "../../../../api/api";
import { getCaseId, getClientId } from "../../../../Utils/helper";

export const uploadCaseDocuments = async (
  files,
  onFileProgress,
  { pageId = null, caseId = getCaseId(), clientId = getClientId() } = {}
) => {
  let uploaded = 0;
  let failed = 0;

  for (const [index, file] of Array.from(files || []).entries()) {
    try {
      onFileProgress?.(index, { status: "uploading", progress: 0 });
      const formData = new FormData();
      formData.append("file", file);
      const response = await api_without_cancellation.post(
        `/api/upload_doc/${clientId}/${caseId}/`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
          onUploadProgress: ({ loaded, total }) => {
            if (total) {
              onFileProgress?.(index, {
                progress: Math.min(95, Math.round((loaded / total) * 95)),
              });
            }
          },
          onFileUploadProgress: (state) => {
            onFileProgress?.(index, {
              ...state,
              status: state.status === "completed" ? "saving" : state.status,
              progress: Math.min(95, Math.round((state.progress || 0) * 0.95)),
            });
          },
        }
      );
      const docId = response.data?.docId;
      if (!docId) throw new Error("The upload did not return a document.");

      onFileProgress?.(index, { status: "saving", progress: 95 });
      const attachment = await api_without_cancellation.post("/api/doc/attach/", {
        page_id: pageId,
        slot: "",
        panel_id: null,
        panels: false,
        case_id: caseId,
        client_id: clientId,
        doc_id: docId,
        file_size: file.size / (1024 * 1024),
      });
      if (attachment.status !== 200 && attachment.status !== 201) {
        throw new Error("The document could not be saved to the case.");
      }
      uploaded += 1;
      onFileProgress?.(index, { status: "completed", progress: 100 });
    } catch (error) {
      failed += 1;
      onFileProgress?.(index, {
        status: error.code === "ERR_CANCELED" ? "cancelled" : "failed",
        error: error.response?.data?.error || error.message || "Upload failed",
      });
      console.error("Document upload failed:", error);
    }
  }

  return { uploaded, failed };
};
